import { dashboardsFiltersDiscovery } from '../api/dashboards_filters'
import type { Resolvers } from '../generated/server/resolvers'

const DashboardsFilter: Resolvers = {
  Query: {
    dashboardsFiltersDiscovery,
  },
}

export default DashboardsFilter
